import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.COMPLEX_SEIZURE_SCREENS_MANAGE}`,
            render: () => import("../../Pages/Nursing/ComplexSeizureScreening/Form/ComplexSeizureScreeningForm.svelte"),
            title: "Complex Seizure Screen"
        }
    ]
};

export default routerConfig;